"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;



















































































































var _fileSaver = _interopRequireDefault(require("file-saver"));
var _xlsx = _interopRequireDefault(require("xlsx"));
var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 引入导出Excel表格依赖
var _default = { data: function data() {return { tableData: [], // 列表数据
      //				droplist: [],
      droplist2: [], searchData: { sn: '', deviceTypeName: '', deviceTypeCode: '', deviceStatus: '', connStatus: '', time: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addpageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', doFirmwareVersionId: '', doFirmwareVersion: '', partCode: '', //					serverHost: '',
        //					serverPort: '',
        sn: '' }, defaultData: { id: '', doFirmwareVersionId: '', doFirmwareVersion: '', partCode: '', //					serverHost: '',
        //					serverPort: '',
        sn: '' }, pickerOptions: { disabledDate: function disabledDate(time) {return time.getTime() > Date.now();} } };}, filters: { deviceStatusFilter: function deviceStatusFilter(val) {if (val.connStatus === 0) {return '--';} else if (val.connStatus != 0) {if (val.deviceStatus === 1) {return '待机';} else if (val.deviceStatus === 2) {return '使用中';} else if (val.deviceStatus === 3) {return '离线';} else if (val.deviceStatus === 4) {return '故障';} else if (val.deviceStatus === 5) {return '暂停';} else if (val.deviceStatus === 6) {return '开机';}}}, connStatusFilter: function connStatusFilter(val) {if (val === 0) {return '离线';} else if (val === 1) {return '在线';}} }, mounted: function mounted() {var self = this;self.init();self.getdrop2();}, methods: { checkPermission: _user.checkPermission, init: function init() {var self = this;var params = Object.assign({}, self.searchData);if (params.time) {params.startTime = params.time[0] + ' 00:00:00';params.endTime = params.time[1] + ' 23::59:59';}delete params['time'];self.getData('/api/baseDeviceMonitor', params, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, // 定义导出Excel表格事件
    // 如果导出的excel文件打开出现"文件已损坏"提示并且不显示内容，安装如下链接解决：https://blog.csdn.net/Frederick_Bala/article/details/93485849
    // exportExcel: function() {
    //   /* 从表生成工作簿对象 */
    //   var wb = XLSX.utils.table_to_book(document.querySelector('#exportTable'))
    //   /* 获取二进制字符串作为输出 */
    //   var wbout = XLSX.write(wb, {
    //     bookType: 'xls', // xlsx
    //     bookSST: true,
    //     type: 'array'
    //   })
    //   try {
    //     FileSaver.saveAs(
    //       // Blob 对象表示一个不可变、原始数据的类文件对象。
    //       // Blob 表示的不一定是JavaScript原生格式的数据。
    //       // File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
    //       // 返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
    //       new Blob([wbout], { type: 'application/octet-stream' }),
    //       // 设置导出文件名称
    //       '设备监控.xls'// xlsx
    //     )
    //   } catch (e) {
    //     if (typeof console !== 'undefined') console.log(e, wbout)
    //   }
    //   return wbout
    // },
    exportExcel: function exportExcel() {var self = this;var day_30 = 3600 * 30 * 24 * 1000; // 校验时间是否填写
      var params = Object.assign({}, self.searchData);if (!params.time) {self.$message({ message: '请选择时间', type: 'error' });return;}if (params.time) {params.startTime = params.time[0] + ' 00:00:00';params.endTime = params.time[1] + ' 23:59:59';}if (params.time && new Date(params.endTime).getTime() - new Date(params.startTime).getTime() > day_30) {self.$message({ message: '只能导出小于等于30天的的时间', type: 'error' });

        return;
      }
      window.location.href = '/api/baseDeviceMonitor/export?startTime=' +
      params.startTime + '&endTime=' + params.endTime + '&deviceTypeCode=' +
      params.deviceTypeCode + '&deviceStatus=' + params.deviceStatus + '&connStatus=' +
      params.connStatus + '&sn=' + params.sn + '&deviceTypeName=' + params.deviceTypeName;
    },

    resetFun: function resetFun() {// 重置
      this.searchData.sn = '';
      this.searchData.deviceTypeName = '';
      this.searchData.deviceTypeCode = '';
      this.searchData.deviceStatus = '';
      this.searchData.connStatus = '';
      this.searchData.time = '';
      this.init();
    },

    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },
    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs['addForm'].resetFields();
      done();
    },
    getdrop2: function getdrop2() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.droplist2 = res;
      });
    },
    changeappTypeFun: function changeappTypeFun(val) {
      var self = this;
      if (val === '13') {
        self.addData.partCode = '13';
      }if (val === '01') {
        self.addData.partCode = '01';
      }
    },
    changeopenMethodFun: function changeopenMethodFun(val) {
      var self = this;
      if (val === '1') {
        self.searchData.deviceStatus = '1';
      } else if (val === '2') {
        self.searchData.deviceStatus = '2';
      } else if (val === '3') {
        self.searchData.deviceStatus = '3';
      } else if (val === '4') {
        self.searchData.deviceStatus = '4';
      } else if (val === '5') {
        self.searchData.deviceStatus = '5';
      } else if (val === '6') {
        self.searchData.deviceStatus = '6';
      }
    },
    connStatusFun: function connStatusFun(val) {
      var self = this;
      if (val === '0') {
        self.searchData.connStatus = '0';
      } else if (val === '1') {
        self.searchData.connStatus = '1';
      }
    } } };exports.default = _default;